// extracted by mini-css-extract-plugin
export default {"root":"sidebar_root__es4ee","arrow":"sidebar_arrow__28yKK","footer":"sidebar_footer__5dPDP","menu":"sidebar_menu__rPTe+"};